module.exports = __webpack_public_path__ + "static/about-hero-tiny-b8368408d194b3a9ed933ae99fe2f9b3.png";